import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";

const FiltersControlField = ({ id }) => {
  const { config, isFilterSet, removeFilter, setFilter, loading } =
    useSolrContext();

  const fieldConfig = config.fields.find((field) => field.id === id);
  const disabled = !!loading;
  const _t = useTranslate();

  const handleClick = (event, value, isSelected) => {
    event.preventDefault();
    if (disabled) return;
    if (isSelected) {
      removeFilter(id, value);
    } else {
      setFilter(id, [value]);
    }
  };

  return (
    <>
      {fieldConfig.values &&
        fieldConfig.values.map((valueConfig, ix) => {
          const isFilterSelected = isFilterSet(id, valueConfig.value);

          const buttonClasses = classNames({
            "filters-control": true,
            "filters-control-field": true,
            "filters-control-field--selected": isFilterSelected,
          });

          const iconClasses = classNames({
            icon: true,
            "icon-headphones": valueConfig.value === "audio",
            "icon-playvideo": valueConfig.value === "video",
            "icon-unknown":
              valueConfig.value !== "audio" && valueConfig.value !== "video",
          });

          return (
            <button
              className={buttonClasses}
              disabled={disabled}
              title={valueConfig.label}
              onClick={(event) =>
                handleClick(event, valueConfig.value, isFilterSelected)
              }
              aria-label={
                isFilterSelected ? _t("filter.delete") : _t("filter.set")
              }
              key={ix}
            >
              <span className={iconClasses} />
              <span className="filters-control-field-label">
                {valueConfig.label}
              </span>
            </button>
          );
        })}
    </>
  );
};

FiltersControlField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FiltersControlField;
